import React, { PropsWithChildren } from 'react';

import { Dialog } from '@paragon/popup-state';

interface Props extends PropsWithChildren {
  cancelMessage: string;
  onCancel(): void;

  confirmMessage: string;
  onConfirm(): void | Promise<unknown>;
}

export function ConfirmationDialog(props: Props) {
  return (
    <Dialog
      insistent
      variant="design"
      cancelText={props.cancelMessage}
      onCancel={props.onCancel}
      submitText={props.confirmMessage}
      onSubmit={props.onConfirm}
    >
      {props.children}
    </Dialog>
  );
}
